/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchPhotoListItem } from './MatchPhotoListItem';
import {
    MatchPhotoListItemFromJSON,
    MatchPhotoListItemFromJSONTyped,
    MatchPhotoListItemToJSON,
    MatchPhotoListItemToJSONTyped,
} from './MatchPhotoListItem';

/**
 * 
 * @export
 * @interface MatchPhotoListResponse
 */
export interface MatchPhotoListResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchPhotoListResponse
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchPhotoListResponse
     */
    tournamentId: string;
    /**
     * 
     * @type {Array<MatchPhotoListItem>}
     * @memberof MatchPhotoListResponse
     */
    photos: Array<MatchPhotoListItem>;
}

/**
 * Check if a given object implements the MatchPhotoListResponse interface.
 */
export function instanceOfMatchPhotoListResponse(value: object): value is MatchPhotoListResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('photos' in value) || value['photos'] === undefined) return false;
    return true;
}

export function MatchPhotoListResponseFromJSON(json: any): MatchPhotoListResponse {
    return MatchPhotoListResponseFromJSONTyped(json, false);
}

export function MatchPhotoListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchPhotoListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'tournamentId': json['tournamentId'],
        'photos': ((json['photos'] as Array<any>).map(MatchPhotoListItemFromJSON)),
    };
}

export function MatchPhotoListResponseToJSON(json: any): MatchPhotoListResponse {
    return MatchPhotoListResponseToJSONTyped(json, false);
}

export function MatchPhotoListResponseToJSONTyped(value?: MatchPhotoListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'tournamentId': value['tournamentId'],
        'photos': ((value['photos'] as Array<any>).map(MatchPhotoListItemToJSON)),
    };
}

